import { createFileRoute } from '@tanstack/react-router'
import i18next from 'i18next'

import PageShell from '@/components/Common/PageShell'
import ErrorState from '@/components/Common/ErrorState'

export const Route = createFileRoute('/billing/')({
  component: () => (
    <PageShell title={i18next.t('title', { ns: 'billing' })}>
      <ErrorState
        title={i18next.t('noPeriodsTitle', { ns: 'billing' })}
        message={i18next.t('noPeriodsMessage', { ns: 'billing' })}
      />
    </PageShell>
  ),
})
